import { useQuery } from "@tanstack/react-query";
import { API } from "../api-map";
import type { User } from "@/types/user";
import type { UseQueryOptions } from "@tanstack/react-query";

const fetchUserData = async (email: string): Promise<User | null> => {
  try {
    const response = await fetch(API.USER_ENDPOINT + "/" + email);
    if (!response.ok) {
      return null;
    }
    return response.json();
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

export const getUserDataOnClient = (
  email: string,
  options?: Omit<UseQueryOptions<User | null>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["userData", email],
    queryFn: () => fetchUserData(email),
    enabled: !!email,
    ...options,
  });
};
